// extracted by mini-css-extract-plugin
export default {"custom-toast":"lfzZVq7EJNCSiXpTXmMhXg=="};